module.exports = __webpack_public_path__ + "static/media/home-bs.c8e66f5f.png";